var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_setup.stockTabList.length)?_c('CommonTab',{attrs:{"type":"rect","value":_setup.stockTabActValue,"option":_setup.stockTabList},on:{"update:value":function($event){_setup.stockTabActValue=$event},"change":_setup.changeStockTab}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }